import { useEffect, useState } from "react";
import Navbar from "../../components/NavBar/Navbar.jsx";
import ItemBoleto from "../../components/ItemBoleto/ItemBoleto.jsx";
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from "../../services/api.jsx";
import { useParams } from "react-router-dom";
import ModalQrCodePix from "../../components/ModalQrCodePIX/ModalQrCodePIX.jsx";

function Boletos () {

   const {cgc} = useParams(); 

   const [ListaBoletos, setListaBoletos] = useState([]);
   const [TotalBoleto, setTotalBoleto] = useState(0);
   const [isItemOpen, setisItemOpen] = useState(false);
   const [QrCodePix, SetQrCodePix] = useState({});


    function closeModalItem(){
        setisItemOpen(false);
    }        

   function ConsultaBoletos (){
            
      api.get('boletos/'+cgc)
      .then((retorno) => {    
         setListaBoletos(retorno.data); 
      })
      .catch((err) => {
         console.log(err);
      });
            

   }

   function CalcularTotal(){
       
      let total = 0;

      ListaBoletos.map((boleto) => {
         total = total + boleto.valor;
      })
      
      setTotalBoleto(total);
   }

  

   useEffect(() => {
      ConsultaBoletos(cgc);  
   },[])

   useEffect(() => {
      CalcularTotal();
   },[ListaBoletos])

   


   return <>
   
     <ModalQrCodePix isOpen={isItemOpen}
                            onRequestClose={closeModalItem} 
                            QrCodePix={QrCodePix}
                            />

      <Navbar />

      

      <div className="col-md-12 text-center mb-4">
         <span className="me-4">Total de Titulos em Aberto:</span>
         <b>
            {
               new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(TotalBoleto)
            }
         </b>

      </div>

      <div className="mt-5 ms-4 me-4">
      
            
           {
                
                ListaBoletos.map((boleto) =>{ 
                  return <ItemBoleto key={boleto.nossonumero}
                                     nossonumero={boleto.nossonumero}
                                     datavencimento={boleto.datavencimento}
                                     notafiscal={boleto.notafiscal}
                                     prest={boleto.prest}
                                     cliente={boleto.cliente}
                                     valor={boleto.valor} 
                                     codbarra={boleto.codbarra}
                                     atrazo={boleto.atrazo} / >
               })
           }
                   


      </div>   
      
      <ToastContainer / >
   </>         

}

export default Boletos;